import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
export function Countdown() {
  const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 minutes in seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 0) {
          return 15 * 60; // Reset to 15 minutes
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="bg-red-600 text-white py-6" data-id="element-68">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-69">
        <div className="flex items-center gap-3" data-id="element-70">
          <Clock className="w-6 h-6" data-id="element-71" />
          <span className="font-bold text-lg" data-id="element-72">La oferta termina en:</span>
        </div>
        <div className="flex gap-2" data-id="element-73">
          <div className="bg-white text-red-600 px-4 py-2 rounded-lg font-bold text-2xl min-w-[60px] text-center" data-id="element-74">
            {String(minutes).padStart(2, '0')}
          </div>
          <div className="flex items-center text-2xl font-bold" data-id="element-75">:</div>
          <div className="bg-white text-red-600 px-4 py-2 rounded-lg font-bold text-2xl min-w-[60px] text-center" data-id="element-76">
            {String(seconds).padStart(2, '0')}
          </div>
        </div>
      </div>
    </motion.div>;
}